import { render, staticRenderFns } from "./Timelinev2.vue?vue&type=template&id=05dcdaf1&scoped=true&"
import script from "./Timelinev2.vue?vue&type=script&lang=js&"
export * from "./Timelinev2.vue?vue&type=script&lang=js&"
import style0 from "./Timelinev2.vue?vue&type=style&index=0&id=05dcdaf1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dcdaf1",
  null
  
)

export default component.exports